import {
  TabListItem,
  TabNavigation,
  useRouteMatch,
} from "~/components/tab-nav";
import { TabPanel } from "~/components/tab-panel";
import { IntegrationType } from "~/operations";
import { createPath, parsePath } from "react-router-dom";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { SecurityPipelineGithubPageTabOverview } from "./SecurityPipelineGithubPageTabOverview/SecurityPipelineGithubPageTabOverview";
import { SecurityPipelineGithubPageTabAutomate } from "./SecurityPipelineGithubPageTabAutomate/SecurityPipelineGithubPageTabAutomate";
import { useSecurityPipelineIntegrations } from "~/pages/integrations/security-pipeline/hooks/useSecurityPipelineIntegrations";

interface SecurityPipelineGithubPageTabsProps {
  scope: SpaceScope | OrganizationScope;
}

export const SecurityPipelineGithubPageTabs = ({
  scope,
}: SecurityPipelineGithubPageTabsProps) => {
  const { integration } = useSecurityPipelineIntegrations();
  const integrationId = integration?.mrn.split("/").pop();
  const integrationPath = `/space/integrations/security_pipeline_github${integrationId ? `/${integrationId}` : ""}?${scope.params}`;
  const generateHref = (tab: string): string => {
    const parsedPath = parsePath(integrationPath);
    const pathname = `${parsedPath.pathname}/${tab}`;
    const search = parsedPath.search;
    return createPath({ pathname, search });
  };

  const tabList: TabListItem[] = [
    {
      label: "Overview",
      to: generateHref("overview"),
      route: "/overview",
    },
    {
      label: "Automate",
      to: generateHref("automate"),
      route: "/automate",
    },
  ];

  const initialTab = "overview";

  const currentTab = useRouteMatch(
    tabList.map((x) => x.route),
    initialTab,
  );

  return (
    <div>
      <TabNavigation
        id={`${IntegrationType.SecurityPipelineGithub}-tabs`}
        tabList={tabList}
        currentTab={currentTab}
      />
      <TabPanel value={currentTab} index="/overview">
        <SecurityPipelineGithubPageTabOverview />
      </TabPanel>
      <TabPanel value={currentTab} index="/automate">
        <SecurityPipelineGithubPageTabAutomate />
      </TabPanel>
    </div>
  );
};
